jQuery(document).ready(function($) {
    if($('.journals-widget').length){
        $('.journals-widget__button button:not(.to-page)').on('click',function(e){
            addWaiting();
            $.ajax({
                type:'POST',
                url: '/wp-admin/admin-ajax.php',
                data:{action:'fw_my_journals_add_edit', 'cur-page':$(this).data('page')},
                dataType:'html',
                success: function(data)
                {
                    addJournal(data);
                    $('#waiting').remove();
                },
                error: function(xhr, desc, err) {
                    console.log(xhr);
                    console.log("Details0: " + desc + "\nError:" + err);
                },
            });
        })
        $(document).on('click','.close,.journals-widget__add-overlay',function(e){
            e.preventDefault;
            if(e.target!=this){
                return;
            }
            $('.new-journal').remove();
        });

        $(document).on('change','.new-journal input',function(e){
            console.log('hi');
            var $this=$(this);
            if($this.prop('type')=='text' &&$this.hasClass('has-maxlength') && $this.prop('maxlength') && $this.val().length>$this.prop('maxlength')){
                $this.val(truncateString($this.val(),$this.prop('maxlength')));
                alert('You have exceeded the maximum length (100) for this value');
                return false;
            }
        });
    }

    if($('.my-journals').length){
        $(document).on('click','.edit-btn',function(e){
            e.preventDefault();
            var $this=$(this);
            var do_action=$this.data('action');
            var entry=$this.data('entry');
            addWaiting();
            $.ajax({
                type:'POST',
                url: '/wp-admin/admin-ajax.php',
                data:{action:'fw_my_journals_add_edit','do_action':do_action,'journal-entry':entry},
                dataType:'html',
                success: function(data)
                {
                    if(do_action=='delete'){
                        if(data=='SUCCESS'){
                            refreshJournals();
                        }
                    }else {
                        addJournal(data);
                        $('#waiting').remove();
                    }
                },
                error: function(xhr, desc, err) {
                    console.log(xhr);
                    console.log("Details0: " + desc + "\nError:" + err);
                },
            });
        });

        $(document).on('click','.button-sort__option',function(e){
            e.preventDefault();
            addWaiting();
            var $this=$(this);
            $('.button-sort__option').removeClass('selected');
            $this.addClass('selected');
            let opts=getJournalOptions();
            refreshJournals('',opts);
        });

        $(document).on('change','.my-journals form input,.my-journals form select',function(e){
            e.preventDefault();
            addWaiting();
            var $this=$(this);
            var $group=$this.closest('.clean-filters__group');
            if($this.hasClass('all')){
                $group.find('input:not(.all)').prop('checked',false);
            }else{
                $group.find('input.all').prop('checked',false);
            }
            let opts=getJournalOptions();
            console.log(opts);
            refreshJournals('',opts);
        });

        $(document).on('click','.my-journals .sort',function(e){
            e.preventDefault();
            addWaiting();
            var $this=$(this);
            let opts=getJournalOptions();
            if($this.hasClass('sort-asc')){
                opts.dateSort='desc';
            }else{
                opts.dateSort='asc';
            }
            refreshJournals('',opts);
        });

        $(document).on('change','#keyword',function(){
            var $this=$(this);
            if($this.val()==''){
                $('#clearkeywords').remove();
            }else{
                $('<i class="fa fa-close" id="clearkeywords"></i>').insertAfter($this);
                $('#clearkeywords').on('click',function(e){
                    e.preventDefault();
                    $('#keyword').val('').trigger('change');
                });
            }
        });
        $(document).on('change','#topic',function(){
            var $this=$(this);
            if($this.val()==''){
                $('#cleartopics').remove();
            }else{
                $('<i class="fa fa-close" id="cleartopics"></i>').insertAfter($this);
                $('#cleartopics').on('click',function(e){
                    e.preventDefault();
                    $('#topic').val('').trigger('change');
                });
            }
        });
    }

    function addJournal(data){
        $('.new-journal').remove();
        $('.journals-widget').append(data);
        $('#entry').attr('required',true);
        $('.new-journal form').on('submit',function(e){
            e.preventDefault();
            var journal=$('.new-journal form').serialize();
            addWaiting();
            $.ajax({
                type:'POST',
                url: '/wp-admin/admin-ajax.php',
                data:'action=fw_my_journals_add_edit&'+journal,
                dataType:'html',
                success: function(data)
                {
                    $('#waiting').remove();
                    if(data=='SUCCESS'){
                        refreshJournals('Success!')
                    }else {
                        addJournal(data);
                        $('#waiting').remove();
                    }
                },
                error: function(xhr, desc, err) {
                    console.log(xhr);
                    console.log("Details0: " + desc + "\nError:" + err);
                },
            });
        });
    }
    function refreshJournals(message='',opts={}){
        console.log(opts);
        $('.new-journal__body').html('<h2>'+message+'</h2>');
        opts.action='fw_my_journals_ajax';
        console.log(opts);
        $.ajax({
            type:'POST',
            url: '/wp-admin/admin-ajax.php',
            data:opts,
            dataType:'html',
            success: function(data)
            {
                $('#the-goals').html(data);
                $('#waiting').remove();
                setTimeout(function(){
                    $('.new-journal').remove();
                }, 2000);
            },
            error: function(xhr, desc, err) {
                console.log(xhr);
                console.log("Details0: " + desc + "\nError:" + err);
            },
        });
    }
    function getJournalOptions(){
        var opts={};
        opts.sort=$('.button-sort__option.selected').data('sort');
        opts.filters=$('.my-journals .clean-filters form').serialize();
        return opts;
    }
});

function truncateString(str, num) {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
        return str
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + '...'
}